import { useMemo } from 'react'

import { useInitializeDocumentFilters, useInitializeDocumentTypes } from './hooks'

interface ContactDocumentsInitializationProps {
  contactId: string
}

export const ContactDocumentsInitialization: React.FC<ContactDocumentsInitializationProps> = ({ contactId }) => {
  const contactIds = useMemo(() => [contactId], [contactId])

  useInitializeDocumentTypes()
  useInitializeDocumentFilters(contactIds)

  return null
}
